export const trackEventMockedData = [
    {
        app: {
            displayName: 'david3.0',
            id: 5681101074857984,
            platform: 'android'
        },
        appId: 5681101074857984,
        createdAt: 1699535130123,
        createdByUser: {
            first: 'System',
            hasLoggedIn: false,
            id: '-42',
            last: 'User',
            role: 0,
            userType: 'normal',
            username: '--system-user--'
        },
        dailyMergeFirst: 0,
        dailyRollupFirst: 0,
        dirty: false,
        eventPropertyNameList: null,
        group: {
            color: '',
            description: '',
            id: '',
            items: null,
            length: 0,
            name: '',
            type: ''
        },
        id: '9A3sGPjgGl5icc1pV2WT2vGp6IQ',
        isCoreEvent: false,
        kind: 'TrackType',
        lastUpdatedAt: 1699535130123,
        lastUpdatedByUser: {
            first: 'System',
            hasLoggedIn: false,
            id: '-42',
            last: 'User',
            role: 0,
            userType: 'normal',
            username: '--system-user--'
        },
        name: 'bla',
        numAccounts: 0,
        numEvents: 0,
        numVisitors: 0,
        rootVersionId: '9A3sGPjgGl5icc1pV2WT2vGp6IQ',
        stableVersionId: '9A3sGPjgGl5icc1pV2WT2vGp6IQ-20231109130530.134837151',
        trackTypeId: '9A3sGPjgGl5icc1pV2WT2vGp6IQ',
        trackTypeName: 'bla',
        trackTypeRules: ['bla'],
        validThrough: 1717308000000
    },
    {
        app: {
            displayName: 'Yoav iOS kitchen sink',
            id: 5711790193246208,
            platform: 'ios'
        },
        appId: 5711790193246208,
        createdAt: 1684068606852,
        createdByUser: {
            first: 'System',
            hasLoggedIn: false,
            id: '-42',
            last: 'User',
            role: 0,
            userType: 'normal',
            username: '--system-user--'
        },
        dailyMergeFirst: 0,
        dailyRollupFirst: 0,
        dirty: false,
        eventPropertyNameList: ['index', 'b'],
        group: {
            color: '',
            description: '',
            id: '',
            items: null,
            length: 0,
            name: '',
            type: ''
        },
        id: 'KV0YuKYdia0JsPruqWzBzjjPjGs',
        isCoreEvent: false,
        kind: 'TrackType',
        lastUpdatedAt: 1684068607381,
        lastUpdatedByUser: {
            first: 'System',
            hasLoggedIn: false,
            id: '-42',
            last: 'User',
            role: 0,
            userType: 'normal',
            username: '--system-user--'
        },
        name: 'item_selected',
        numAccounts: 0,
        numEvents: 0,
        numVisitors: 0,
        rootVersionId: 'KV0YuKYdia0JsPruqWzBzjjPjGs',
        stableVersionId: 'KV0YuKYdia0JsPruqWzBzjjPjGs-20230514125007.591795681',
        trackTypeId: 'KV0YuKYdia0JsPruqWzBzjjPjGs',
        trackTypeName: 'item_selected',
        trackTypeRules: ['item_selected'],
        validThrough: 1717304400000
    },
    {
        app: {
            displayName: 'Yoav - Android',
            id: 5751612878356480,
            platform: 'android'
        },
        appId: 5751612878356480,
        createdAt: 1687432905265,
        createdByUser: {
            first: 'System',
            hasLoggedIn: false,
            id: '-42',
            last: 'User',
            role: 0,
            userType: 'normal',
            username: '--system-user--'
        },
        dailyMergeFirst: 0,
        dailyRollupFirst: 0,
        dirty: false,
        eventPropertyNameList: ['prop1', 'value'],
        group: {
            color: '',
            description: '',
            id: '',
            items: null,
            length: 0,
            name: '',
            type: ''
        },
        id: '1IgQ8Hun1P5oLE454XymwrsE-BQ',
        isCoreEvent: false,
        kind: 'TrackType',
        lastUpdatedAt: 1687432909811,
        lastUpdatedByUser: {
            first: 'System',
            hasLoggedIn: false,
            id: '-42',
            last: 'User',
            role: 0,
            userType: 'normal',
            username: '--system-user--'
        },
        name: 'track event - 2',
        numAccounts: 0,
        numEvents: 0,
        numVisitors: 0,
        rootVersionId: '1IgQ8Hun1P5oLE454XymwrsE-BQ',
        stableVersionId: '1IgQ8Hun1P5oLE454XymwrsE-BQ-20230622112151.070198960',
        trackTypeId: '1IgQ8Hun1P5oLE454XymwrsE-BQ',
        trackTypeName: 'track event - 2',
        trackTypeRules: ['track event - 2'],
        validThrough: 1717304400000
    },
    {
        app: {
            displayName: 'david3.0',
            id: 5681101074857984,
            platform: 'android'
        },
        appId: 5681101074857984,
        createdAt: 1699535130490,
        createdByUser: {
            first: 'System',
            hasLoggedIn: false,
            id: '-42',
            last: 'User',
            role: 0,
            userType: 'normal',
            username: '--system-user--'
        },
        dailyMergeFirst: 0,
        dailyRollupFirst: 0,
        dirty: false,
        eventPropertyNameList: null,
        group: {
            color: '',
            description: '',
            id: '',
            items: null,
            length: 0,
            name: '',
            type: ''
        },
        id: 'F8J0k-Wyxny4qLBH4PAWxuIr4vg',
        isCoreEvent: false,
        kind: 'TrackType',
        lastUpdatedAt: 1699535130490,
        lastUpdatedByUser: {
            first: 'System',
            hasLoggedIn: false,
            id: '-42',
            last: 'User',
            role: 0,
            userType: 'normal',
            username: '--system-user--'
        },
        name: 'bla222',
        numAccounts: 0,
        numEvents: 0,
        numVisitors: 0,
        rootVersionId: 'F8J0k-Wyxny4qLBH4PAWxuIr4vg',
        stableVersionId: 'F8J0k-Wyxny4qLBH4PAWxuIr4vg-20231109130530.518310037',
        trackTypeId: 'F8J0k-Wyxny4qLBH4PAWxuIr4vg',
        trackTypeName: 'bla222',
        trackTypeRules: ['bla222'],
        validThrough: 1717308000000
    },
    {
        app: {
            displayName: 'david3.0',
            id: 5681101074857984,
            platform: 'android'
        },
        appId: 5681101074857984,
        createdAt: 1700395522944,
        createdByUser: {
            first: 'System',
            hasLoggedIn: false,
            id: '-42',
            last: 'User',
            role: 0,
            userType: 'normal',
            username: '--system-user--'
        },
        dailyMergeFirst: 0,
        dailyRollupFirst: 0,
        dirty: false,
        eventPropertyNameList: null,
        group: {
            color: '',
            description: '',
            id: '',
            items: null,
            length: 0,
            name: '',
            type: ''
        },
        id: 'IpauejvxIPR-1K9aEW-jv9gHh0o',
        isCoreEvent: false,
        kind: 'TrackType',
        lastUpdatedAt: 1700395522944,
        lastUpdatedByUser: {
            first: 'System',
            hasLoggedIn: false,
            id: '-42',
            last: 'User',
            role: 0,
            userType: 'normal',
            username: '--system-user--'
        },
        name: 'TrackEventOfStartSession',
        numAccounts: 0,
        numEvents: 0,
        numVisitors: 0,
        rootVersionId: 'IpauejvxIPR-1K9aEW-jv9gHh0o',
        stableVersionId: 'IpauejvxIPR-1K9aEW-jv9gHh0o-20231119120523.105457894',
        trackTypeId: 'IpauejvxIPR-1K9aEW-jv9gHh0o',
        trackTypeName: 'TrackEventOfStartSession',
        trackTypeRules: ['TrackEventOfStartSession'],
        validThrough: 1717308000000
    },
    {
        app: {
            displayName: 'david3.0',
            id: 5681101074857984,
            platform: 'android'
        },
        appId: 5681101074857984,
        createdAt: 1699535130381,
        createdByUser: {
            first: 'System',
            hasLoggedIn: false,
            id: '-42',
            last: 'User',
            role: 0,
            userType: 'normal',
            username: '--system-user--'
        },
        dailyMergeFirst: 0,
        dailyRollupFirst: 0,
        dirty: false,
        eventPropertyNameList: null,
        group: {
            color: '',
            description: '',
            id: '',
            items: null,
            length: 0,
            name: '',
            type: ''
        },
        id: 'WAfcPNHYsl-eMHOLuskzwDPzNPU',
        isCoreEvent: false,
        kind: 'TrackType',
        lastUpdatedAt: 1699535130381,
        lastUpdatedByUser: {
            first: 'System',
            hasLoggedIn: false,
            id: '-42',
            last: 'User',
            role: 0,
            userType: 'normal',
            username: '--system-user--'
        },
        name: 'bla22',
        numAccounts: 0,
        numEvents: 0,
        numVisitors: 0,
        rootVersionId: 'WAfcPNHYsl-eMHOLuskzwDPzNPU',
        stableVersionId: 'WAfcPNHYsl-eMHOLuskzwDPzNPU-20231109130530.398923152',
        trackTypeId: 'WAfcPNHYsl-eMHOLuskzwDPzNPU',
        trackTypeName: 'bla22',
        trackTypeRules: ['bla22'],
        validThrough: 1717308000000
    },
    {
        app: {
            displayName: 'Yoav - Android',
            id: 5751612878356480,
            platform: 'android'
        },
        appId: 5751612878356480,
        createdAt: 1687436509060,
        createdByUser: {
            first: 'System',
            hasLoggedIn: false,
            id: '-42',
            last: 'User',
            role: 0,
            userType: 'normal',
            username: '--system-user--'
        },
        dailyMergeFirst: 0,
        dailyRollupFirst: 0,
        dirty: false,
        eventPropertyNameList: ['duck', 'giraffe', 'lion', 'zebra'],
        group: {
            color: '',
            description: '',
            id: '',
            items: null,
            length: 0,
            name: '',
            type: ''
        },
        id: 'gAjEb5idf0LtC_uff6qg6-3DoGc',
        isCoreEvent: false,
        kind: 'TrackType',
        lastUpdatedAt: 1687436513361,
        lastUpdatedByUser: {
            first: 'System',
            hasLoggedIn: false,
            id: '-42',
            last: 'User',
            role: 0,
            userType: 'normal',
            username: '--system-user--'
        },
        name: 'giraffe_track',
        numAccounts: 0,
        numEvents: 0,
        numVisitors: 0,
        rootVersionId: 'gAjEb5idf0LtC_uff6qg6-3DoGc',
        stableVersionId: 'gAjEb5idf0LtC_uff6qg6-3DoGc-20230622122154.219517822',
        trackTypeId: 'gAjEb5idf0LtC_uff6qg6-3DoGc',
        trackTypeName: 'giraffe_track',
        trackTypeRules: ['giraffe_track'],
        validThrough: 1717304400000
    },
    {
        app: {
            displayName: 'Yoav - Android',
            id: 5751612878356480,
            platform: 'android'
        },
        appId: 5751612878356480,
        createdAt: 1686040547846,
        createdByUser: {
            first: 'System',
            hasLoggedIn: false,
            id: '-42',
            last: 'User',
            role: 0,
            userType: 'normal',
            username: '--system-user--'
        },
        dailyMergeFirst: 0,
        dailyRollupFirst: 0,
        dirty: false,
        eventPropertyNameList: ['itemId'],
        group: {
            color: '',
            description: '',
            id: '',
            items: null,
            length: 0,
            name: '',
            type: ''
        },
        id: 'tEsDEs9wEMjHZn2a4wnKikgN84g',
        isCoreEvent: false,
        kind: 'TrackType',
        lastUpdatedAt: 1686040550041,
        lastUpdatedByUser: {
            first: 'System',
            hasLoggedIn: false,
            id: '-42',
            last: 'User',
            role: 0,
            userType: 'normal',
            username: '--system-user--'
        },
        name: 'screen1',
        numAccounts: 0,
        numEvents: 0,
        numVisitors: 0,
        rootVersionId: 'tEsDEs9wEMjHZn2a4wnKikgN84g',
        stableVersionId: 'tEsDEs9wEMjHZn2a4wnKikgN84g-20230606083551.179796963',
        trackTypeId: 'tEsDEs9wEMjHZn2a4wnKikgN84g',
        trackTypeName: 'screen1',
        trackTypeRules: ['screen1'],
        validThrough: 1717304400000
    },
    {
        app: {
            displayName: 'Yoav - Android',
            id: 5751612878356480,
            platform: 'android'
        },
        appId: 5751612878356480,
        createdAt: 1684921897812,
        createdByUser: {
            first: 'System',
            hasLoggedIn: false,
            id: '-42',
            last: 'User',
            role: 0,
            userType: 'normal',
            username: '--system-user--'
        },
        dailyMergeFirst: 0,
        dailyRollupFirst: 0,
        dirty: false,
        eventPropertyNameList: null,
        group: {
            color: '',
            description: '',
            id: '',
            items: null,
            length: 0,
            name: '',
            type: ''
        },
        id: 'gWXcYdoyHAXh0zmLZAHiuFqUUf0',
        isCoreEvent: false,
        kind: 'TrackType',
        lastUpdatedAt: 1684921897812,
        lastUpdatedByUser: {
            first: 'System',
            hasLoggedIn: false,
            id: '-42',
            last: 'User',
            role: 0,
            userType: 'normal',
            username: '--system-user--'
        },
        name: 'track',
        numAccounts: 0,
        numEvents: 0,
        numVisitors: 0,
        rootVersionId: 'gWXcYdoyHAXh0zmLZAHiuFqUUf0',
        stableVersionId: 'gWXcYdoyHAXh0zmLZAHiuFqUUf0-20230524095137.830120960',
        trackTypeId: 'gWXcYdoyHAXh0zmLZAHiuFqUUf0',
        trackTypeName: 'track',
        trackTypeRules: ['track'],
        validThrough: 1717304400000
    },
    {
        app: {
            displayName: 'Yoav iOS kitchen sink',
            id: 5711790193246208,
            platform: 'ios'
        },
        appId: 5711790193246208,
        createdAt: 1710935429852,
        createdByUser: {
            first: 'System',
            hasLoggedIn: false,
            id: '-42',
            last: 'User',
            role: 0,
            userType: 'normal',
            username: '--system-user--'
        },
        dailyMergeFirst: 0,
        dailyRollupFirst: 0,
        dirty: false,
        eventPropertyNameList: ['king', 'queen'],
        group: {
            color: '',
            description: '',
            id: '',
            items: null,
            length: 0,
            name: '',
            type: ''
        },
        id: 'nL7RIa0db0QAKeQMclX1Ww1teKo',
        isCoreEvent: false,
        kind: 'TrackType',
        lastUpdatedAt: 1710935429852,
        lastUpdatedByUser: {
            first: 'System',
            hasLoggedIn: false,
            id: '-42',
            last: 'User',
            role: 0,
            userType: 'normal',
            username: '--system-user--'
        },
        name: 'simple_alert',
        numAccounts: 1,
        numEvents: 1,
        numVisitors: 1,
        rootVersionId: 'nL7RIa0db0QAKeQMclX1Ww1teKo',
        stableVersionId: 'nL7RIa0db0QAKeQMclX1Ww1teKo-20240320115029.870515369',
        trackTypeId: 'nL7RIa0db0QAKeQMclX1Ww1teKo',
        trackTypeName: 'simple_alert',
        trackTypeRules: ['simple_alert'],
        validThrough: 1717304400000
    },
    {
        app: {
            displayName: 'Yoav iOS kitchen sink',
            id: 5711790193246208,
            platform: 'ios'
        },
        appId: 5711790193246208,
        createdAt: 1684068606554,
        createdByUser: {
            first: 'System',
            hasLoggedIn: false,
            id: '-42',
            last: 'User',
            role: 0,
            userType: 'normal',
            username: '--system-user--'
        },
        dailyMergeFirst: 0,
        dailyRollupFirst: 0,
        dirty: false,
        eventPropertyNameList: ['prop1', 'prop2', 'prop3', 'prop4'],
        group: {
            color: '',
            description: '',
            id: '',
            items: null,
            length: 0,
            name: '',
            type: ''
        },
        id: 'F01RXRLX72NQTm6FOcXU6RcaBg8',
        isCoreEvent: false,
        kind: 'TrackType',
        lastUpdatedAt: 1684068607381,
        lastUpdatedByUser: {
            first: 'System',
            hasLoggedIn: false,
            id: '-42',
            last: 'User',
            role: 0,
            userType: 'normal',
            username: '--system-user--'
        },
        name: 'numeric_track_event',
        numAccounts: 1,
        numEvents: 6,
        numVisitors: 1,
        rootVersionId: 'F01RXRLX72NQTm6FOcXU6RcaBg8',
        stableVersionId: 'F01RXRLX72NQTm6FOcXU6RcaBg8-20230514125007.493754675',
        trackTypeId: 'F01RXRLX72NQTm6FOcXU6RcaBg8',
        trackTypeName: 'numeric_track_event',
        trackTypeRules: ['numeric_track_event'],
        validThrough: 1717304400000
    },
    {
        app: {
            displayName: 'Yoav - Android',
            id: 5751612878356480,
            platform: 'android'
        },
        appId: 5751612878356480,
        createdAt: 1687462585145,
        createdByUser: {
            first: 'System',
            hasLoggedIn: false,
            id: '-42',
            last: 'User',
            role: 0,
            userType: 'normal',
            username: '--system-user--'
        },
        dailyMergeFirst: 0,
        dailyRollupFirst: 0,
        dirty: false,
        eventPropertyNameList: null,
        group: {
            color: '',
            description: '',
            id: '',
            items: null,
            length: 0,
            name: '',
            type: ''
        },
        id: 'WCtAbNv0hog5IpS2CT1ZhTwYekI',
        isCoreEvent: false,
        kind: 'TrackType',
        lastUpdatedAt: 1687462585145,
        lastUpdatedByUser: {
            first: 'System',
            hasLoggedIn: false,
            id: '-42',
            last: 'User',
            role: 0,
            userType: 'normal',
            username: '--system-user--'
        },
        name: 'Blah',
        numAccounts: 0,
        numEvents: 0,
        numVisitors: 0,
        rootVersionId: 'WCtAbNv0hog5IpS2CT1ZhTwYekI',
        stableVersionId: 'WCtAbNv0hog5IpS2CT1ZhTwYekI-20230622193625.161075420',
        trackTypeId: 'WCtAbNv0hog5IpS2CT1ZhTwYekI',
        trackTypeName: 'Blah',
        trackTypeRules: ['Blah'],
        validThrough: 1717304400000
    },
    {
        app: {
            displayName: 'Yoav iOS kitchen sink',
            id: 5711790193246208,
            platform: 'ios'
        },
        appId: 5711790193246208,
        createdAt: 1704626422711,
        createdByUser: {
            first: 'System',
            hasLoggedIn: false,
            id: '-42',
            last: 'User',
            role: 0,
            userType: 'normal',
            username: '--system-user--'
        },
        dailyMergeFirst: 0,
        dailyRollupFirst: 0,
        dirty: false,
        eventPropertyNameList: ['a', 'b'],
        group: {
            color: '',
            description: '',
            id: '',
            items: null,
            length: 0,
            name: '',
            type: ''
        },
        id: 'YZgKoHe7IhZLOmF1BZCuhr7dsAI',
        isCoreEvent: false,
        kind: 'TrackType',
        lastUpdatedAt: 1704626422711,
        lastUpdatedByUser: {
            first: 'System',
            hasLoggedIn: false,
            id: '-42',
            last: 'User',
            role: 0,
            userType: 'normal',
            username: '--system-user--'
        },
        name: 'TrackEventOfStartSession',
        numAccounts: 1,
        numEvents: 69,
        numVisitors: 2,
        rootVersionId: 'YZgKoHe7IhZLOmF1BZCuhr7dsAI',
        stableVersionId: 'YZgKoHe7IhZLOmF1BZCuhr7dsAI-20240107112022.728089455',
        trackTypeId: 'YZgKoHe7IhZLOmF1BZCuhr7dsAI',
        trackTypeName: 'TrackEventOfStartSession',
        trackTypeRules: ['TrackEventOfStartSession'],
        validThrough: 1717304400000
    },
    {
        app: {
            displayName: 'Yoav - Android',
            id: 5751612878356480,
            platform: 'android'
        },
        appId: 5751612878356480,
        createdAt: 1691404564059,
        createdByUser: {
            first: 'System',
            hasLoggedIn: false,
            id: '-42',
            last: 'User',
            role: 0,
            userType: 'normal',
            username: '--system-user--'
        },
        dailyMergeFirst: 0,
        dailyRollupFirst: 0,
        dirty: false,
        eventPropertyNameList: null,
        group: {
            color: '',
            description: '',
            id: '',
            items: null,
            length: 0,
            name: '',
            type: ''
        },
        id: 'Y7CX9Oi_ObQwfIbE08RqJAAmqrA',
        isCoreEvent: false,
        kind: 'TrackType',
        lastUpdatedAt: 1691404564059,
        lastUpdatedByUser: {
            first: 'System',
            hasLoggedIn: false,
            id: '-42',
            last: 'User',
            role: 0,
            userType: 'normal',
            username: '--system-user--'
        },
        name: 'TrackEventOfStartSession',
        numAccounts: 1,
        numEvents: 5,
        numVisitors: 1,
        rootVersionId: 'Y7CX9Oi_ObQwfIbE08RqJAAmqrA',
        stableVersionId: 'Y7CX9Oi_ObQwfIbE08RqJAAmqrA-20230807103604.559907789',
        trackTypeId: 'Y7CX9Oi_ObQwfIbE08RqJAAmqrA',
        trackTypeName: 'TrackEventOfStartSession',
        trackTypeRules: ['TrackEventOfStartSession'],
        validThrough: 1717304400000
    },
    {
        app: {
            displayName: 'Yoav - Android',
            id: 5751612878356480,
            platform: 'android'
        },
        appId: 5751612878356480,
        createdAt: 1678010725293,
        createdByUser: {
            first: 'System',
            hasLoggedIn: false,
            id: '-42',
            last: 'User',
            role: 0,
            userType: 'normal',
            username: '--system-user--'
        },
        dailyMergeFirst: 0,
        dailyRollupFirst: 0,
        dirty: false,
        eventPropertyNameList: ['index', 'item', 'value'],
        group: {
            color: '',
            description: '',
            id: '',
            items: null,
            length: 0,
            name: '',
            type: ''
        },
        id: 'DWNuagMjzt7JPsvkbfhAa_d6BPw',
        isCoreEvent: false,
        kind: 'TrackType',
        lastUpdatedAt: 1678698584123,
        lastUpdatedByUser: {
            first: 'Yoav',
            hasLoggedIn: true,
            id: '5642933638266880',
            jobRole: 'Other',
            last: 'Pelled',
            lastLogin: 1717080074417,
            role: 8,
            useCase: "I'm not sure",
            userType: 'normal',
            username: 'yoav.pelled@pendo.io'
        },
        name: 'item_selected',
        numAccounts: 0,
        numEvents: 0,
        numVisitors: 0,
        rootVersionId: 'DWNuagMjzt7JPsvkbfhAa_d6BPw',
        stableVersionId: 'DWNuagMjzt7JPsvkbfhAa_d6BPw-20230313090944.178324673',
        trackTypeId: 'DWNuagMjzt7JPsvkbfhAa_d6BPw',
        trackTypeName: 'item_selected',
        trackTypeRules: ['item_selected'],
        validThrough: 1717304400000
    },
    {
        app: {
            displayName: 'david3.0',
            id: 5681101074857984,
            platform: 'android'
        },
        appId: 5681101074857984,
        createdAt: 1699535130271,
        createdByUser: {
            first: 'System',
            hasLoggedIn: false,
            id: '-42',
            last: 'User',
            role: 0,
            userType: 'normal',
            username: '--system-user--'
        },
        dailyMergeFirst: 0,
        dailyRollupFirst: 0,
        dirty: false,
        eventPropertyNameList: null,
        group: {
            color: '',
            description: '',
            id: '',
            items: null,
            length: 0,
            name: '',
            type: ''
        },
        id: 'QfUkHS6MbtSuQm9oRZwnnxYYz2k',
        isCoreEvent: false,
        kind: 'TrackType',
        lastUpdatedAt: 1699535130271,
        lastUpdatedByUser: {
            first: 'System',
            hasLoggedIn: false,
            id: '-42',
            last: 'User',
            role: 0,
            userType: 'normal',
            username: '--system-user--'
        },
        name: 'bla2',
        numAccounts: 0,
        numEvents: 0,
        numVisitors: 0,
        rootVersionId: 'QfUkHS6MbtSuQm9oRZwnnxYYz2k',
        stableVersionId: 'QfUkHS6MbtSuQm9oRZwnnxYYz2k-20231109130530.285612189',
        trackTypeId: 'QfUkHS6MbtSuQm9oRZwnnxYYz2k',
        trackTypeName: 'bla2',
        trackTypeRules: ['bla2'],
        validThrough: 1717308000000
    }
];

export const mockedColumns = [
    {
        fixed: true,
        label: 'Name',
        prop: 'name',
        slot: 'name',
        sortable: true,
        type: 'link',
        width: 400,
        visible: true
    },
    {
        prop: 'description',
        label: 'Description',
        sortable: true,
        showOverflow: 'clamp',
        width: 250,
        minWidth: 130,
        visible: true
    },
    {
        label: 'App',
        prop: 'app.displayName',
        slot: 'app',
        sortable: true,
        width: 230,
        visible: true
    },
    {
        async: true,
        label: 'Number of Accounts',
        prop: 'numAccounts',
        sortable: true,
        width: 200,
        visible: true
    },
    {
        async: true,
        label: 'Number of Visitors',
        prop: 'numVisitors',
        sortable: true,
        width: 200,
        visible: true
    },
    {
        async: true,
        label: 'Number of Track Events',
        prop: 'numEvents',
        sortable: true,
        width: 250,
        visible: true
    }
];
